export const sanitizeHtml = (html) => {
  //todo sanitize html
  return { __html: html }
}
